import { render, staticRenderFns } from "./science.vue?vue&type=template&id=6b3c3082&"
import script from "./science.vue?vue&type=script&lang=js&"
export * from "./science.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports